import BackIcon from './back_icon.svg';
import InfoIconWeb from './info.svg?component';
import WhatsappIcon from './whatsapp-icon.svg';
import WhatsappWhiteBorder from './whatapp-white-border.svg';
import ZotokWhiteBorder from './zotok-white-border.svg';
import BroadcastWhiteBorder from './broadcast-white-border.svg';
import ZoeyIcon from './zoey-icon.svg';
import ArrowDownWeb from './arrow-down.svg?component';
import ForwardArrowWeb from './forward.svg?component';
import EyeWeb from './eye.svg?component';
import CopyWeb from './copy.svg?component';
import EditWeb from './edit.svg?component';
import EditNative from './edit.svg';
import ReplyWeb from './reply.svg?component';
import DeleteWeb from './delete.svg?component';
import SpinnerWeb from './spinner.svg?component';
import IssueWeb from './issue.svg?component';
import Emoji from './emoji.svg';
import AirplaneWeb from './airplane.svg?component';
import CloseWeb from './close.svg?component';
import AddButtonWeb from './add-button.svg?component';
import UploadArrowWeb from './upload-arrow.svg?component';
import Photos from './photo.svg';
import Camera from './camera.svg';
import Files from './files.svg';
import CreateOrderWeb from './create-order-web.svg?component';
import PricesWeb from './prices-web.svg?component';
import SchemeWeb from './scheme-web.svg?component';
import InvoiceWeb from './invoice-web.svg?component';
import DispatchNoteWeb from './Dispatch Note.svg?component';
import OrderReceiptWeb from './Order Receipt.svg?component';
import PaymentReceiptWeb from './Payment Receipt.svg?component';

import TemplateWeb from './template-web.svg?component';
import PaymentWeb from './payment-web.svg?component';
import LedgerWeb from './ledger-web.svg?component';
import CampaignWeb from './campaign-web.svg?component';
import CloseCircleWeb from './x-circle.svg?component';
import Lock from './lock.svg';
import CsvFile from './csv_file.svg';
import PdfFile from './pdf_file.svg';
import XlsFile from './xls_file.svg';
import TextFile from './text_file.svg';
import UnknownFile from './unknown_file.svg';
import DispatchIconWeb from './dispatch-web.svg?component';
import DispatchIcon from './dispatch-web.svg';
import RedirectWeb from './redirect.svg?component';
import BrownSpinner from './brown_spinner.svg';
import VerifiedAccount from './verified_account.svg';
import CheckMark from './check_mark.svg';
import MarketInfoIcon from './market.svg';
import CheckIn from './check-in.svg';
import GreenTickCheckIn from './green-tick-check-in.svg';
import CartIcon from './cart.svg?component';

import ChatAvatarOrder from './chat-avatar-order.svg';
import ChatAvatarDispatch from './chat-avatar-dispatch.svg';
import ChatAvatarGeneral from './chat-avatar-general.svg';
import ChatAvatarInvoice from './chat-avatar-invoice.svg';
import ChatAvatarPayment from './chat-avatar-payment.svg';

import MsgFailed from './msg-failed.svg';
import UnsubscribeWeb from './unsubscribe-msg.svg?component';
import UnsubscribeRedWeb from './unsubscribe-msg-red.svg?component';

import InfoGreyWeb from './info-grey.svg?component';
import WarningRed from './warning.svg';
import Share from './share.svg';
import CopyGreyComponent from './copy-grey.svg?component';
import TickCircleGreen from './tick-circle.svg';

import ImpressionWeb from './impression.svg?component';
import EngagedWeb from './engaged.svg?component';
import OrderedWeb from './ordered.svg?component';
import ExpandEmojies from './ExpandEmojies.svg';
import ExpandEmojiesSelected from './ExpandEmojiesSelected.svg';
import HamburgerMenu from './HamburgerMenu.svg';
import TagBlackOutline from './tag-black-outline.svg?component';
import SendComponent from './send-outline.svg?component';
import Send from './send-outline.svg';
import FileUploadComponent from './file-upload.svg?component';
import FileUpload from './file-upload.svg';
import AiAgent from './ai-agent.svg?component';
import NotePad from './note-pad.svg';
import UserSmall from './user-small.svg';
import PlayIcon from './play_icon.svg';
import PauseIcon from './pause_icon.svg';
import DownloadIcon from './download_icon.svg';
import BlueCheck from './blue-check.svg';
import GroupCards from './group-cards.svg';
import GroupUser from './group-user.svg?component';
import ShortCutKeyWord from './shortcut-keyword.svg?component';
import ctrlIcon from './ctrlIcon.svg?component';
import F2Icon from './f2-icon.svg?component';
import tabIcon from './tab-icon.svg?component';
import Signal from './signal.svg?component';

export const ChatSVGS = {
  BlueCheck,
  DownloadIcon,
  PlayIcon,
  PauseIcon,
  MarketInfoIcon,
  BackIcon,
  NotePad,
  UserSmall,
  Dispatch: DispatchIconWeb,
  DispatchIcon: DispatchIcon,
  InfoIcon: InfoIconWeb,
  WhatsappIcon,
  WhatsappWhiteBorder,
  ZotokWhiteBorder,
  BroadcastWhiteBorder,
  ZoeyIcon,
  ArrowDown: ArrowDownWeb,
  Forward: ForwardArrowWeb,
  Eye: EyeWeb,
  Copy: CopyWeb,
  Edit: EditWeb,
  EditOutline: EditNative,
  Reply: ReplyWeb,
  Delete: DeleteWeb,
  Spinner: SpinnerWeb,
  Issue: IssueWeb,
  Emoji,
  Bot: AiAgent,
  Airplane: AirplaneWeb,
  Close: CloseWeb,
  AddButton: AddButtonWeb,
  UploadArrow: UploadArrowWeb,
  Photos,
  Camera,
  Files,
  ExpandEmojiesSelected: ExpandEmojiesSelected,
  CreateOrder: CreateOrderWeb,
  Prices: PricesWeb,
  Scheme: SchemeWeb,
  Invoice: InvoiceWeb,
  DispatchNote: DispatchNoteWeb,
  OrderReceipt: OrderReceiptWeb,
  PaymentReceipt: PaymentReceiptWeb,
  Template: TemplateWeb,
  Ledger: LedgerWeb,
  Payment: PaymentWeb,
  Campaign: CampaignWeb,
  UploadInvoice: InvoiceWeb,
  CloseCircle: CloseCircleWeb,
  CollectPayment: PaymentWeb,
  Lock,
  CartIcon,
  CsvFile,
  PdfFile,
  XlsFile,
  TextFile,
  UnknownFile,
  BrownSpinner,
  VerifiedAccount,
  CheckMark,
  CheckIn,
  GreenTickCheckIn,
  Redirect: RedirectWeb,
  ChatAvatarOrder,
  ChatAvatarDispatch,
  ChatAvatarGeneral,
  ChatAvatarInvoice,
  ChatAvatarPayment,
  MsgFailed,
  Unsubscribe: UnsubscribeRedWeb,
  UnsubscribeBlack: UnsubscribeWeb,
  MessageInfo: InfoGreyWeb,
  WarningRed,
  Share,
  CopyGrey: CopyGreyComponent,
  TickCircleGreen,
  Impression: ImpressionWeb,
  Engaged: EngagedWeb,
  Ordered: OrderedWeb,
  ExpandEmojies: ExpandEmojies,
  HamburgerMenu: HamburgerMenu,
  Tag: TagBlackOutline,
  Send,
  SendComponent,
  FileUpload,
  FileUploadComponent,
  GroupCards,
  GroupUser,
  ShortCutKeyWord,
  ctrlIcon,
  F2Icon,
  tabIcon,
  Signal,
};
